import moment from 'moment-timezone';

/**
 * Calculates the horizontal position of an activity block on the timeline grid.
 *
 * @param {{ fromTimestamp: string, toTimestamp: string }} activity - The activity to position.
 * @param {Array<{ moment: string|import('moment-timezone').Moment }>} dateRange - Visible days on the grid, one entry per day.
 * @param {string} timezone - IANA timezone string used to align both the activity and the grid bounds.
 * @returns {{ leftPercent: number, widthPercent: number } | null} Percentage offsets, or null if the activity is outside the visible range.
 */
export const calculateActivityPosition = (activity, dateRange, timezone) => {
	const activityStart = moment(activity.fromTimestamp).tz(timezone);
	const activityEnd = moment(activity.toTimestamp).tz(timezone);

	const timelineStart = moment(dateRange[0].moment).tz(timezone).startOf('day');
	const timelineEnd = moment(dateRange[dateRange.length - 1].moment)
		.tz(timezone)
		.endOf('day');

	if (activityEnd.isBefore(timelineStart) || activityStart.isAfter(timelineEnd)) {
		return null;
	}

	const truncatedStart = activityStart.isBefore(timelineStart) ? timelineStart : activityStart;
	const truncatedEnd = activityEnd.isAfter(timelineEnd) ? timelineEnd : activityEnd;

	const totalTimelineMinutes = timelineEnd.diff(timelineStart, 'minutes');
	const activityOffsetMinutes = truncatedStart.diff(timelineStart, 'minutes');
	const activityDurationMinutes = truncatedEnd.diff(truncatedStart, 'minutes');

	const leftPercent = (activityOffsetMinutes / totalTimelineMinutes) * 100;
	const widthPercent = (activityDurationMinutes / totalTimelineMinutes) * 100;

	return {
		leftPercent,
		widthPercent,
	};
};
